
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product-releases",
      function () {
        return require("private-next-pages/product-releases.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product-releases"])
      });
    }
  